export default (str) => {
    // Remove whitespace and replace with dashes
    let url = str.trim().replace(/\s+/g, '-');

    // Remove any non-alphanumeric or non-dash characters
    url = url.replace(/[^a-zA-Z0-9-]/g, '');
    
    url = url.toLowerCase();
    return url;
}